import apiServiceOld from './api-service-old';
import { DefaultService } from './generated';

class ApiService extends DefaultService {
  static old = apiServiceOld;
}

export type ApiServiceType = typeof ApiService;

export const useApiService = () => {
  return ApiService;
};
